import {
    GetSkillsQuestAssignmentActionParams,
    GetSkillsQuestCurrentAssignmentParams,
    GetSkillsQuestSelectedAssignmentsParams,
    ManageSkillsQuestCellAssignmentsSelectedParams,
    ManageSkillsQuestSelectedAssignmentsProps,
    UpdateSkillsQuestAssignmentsParams
} from './assignments-selected-helpers.types';
import {
    updateRouteSelectedAssignment
} from '@containers/activity-router/routes/helpers/assignment/assignment-selected/route-assignments-selected';
import { parseActivityKey } from '@containers/activity-router/routes/helpers/keys/key-generator';
import { AssignmentActions } from '@containers/activity-router/routes/helpers/slice/slice.types';

const {
    assign,
    reassign,
    unassign,
    modify
} = AssignmentActions;

export function getSkillsQuestCurrentAssignment ({
    activityKey,
    studentKey,
    studentAssignments
}: GetSkillsQuestCurrentAssignmentParams) {
    const { id } = parseActivityKey(activityKey);
    const selectedAssignment = studentAssignments[studentKey]?.assignments.find((item) =>
        item.learningJourneyId.toString() === id) || null;

    return selectedAssignment || null;
}

function getAssignmentAction ({ currentAssignment }: GetSkillsQuestAssignmentActionParams) {
    if (
        !currentAssignment ||
        (!currentAssignment.currentAssignmentId && currentAssignment.resultAccuracy === undefined)
    ) return [assign];

    if (currentAssignment.currentAssignmentId) return [unassign, modify];

    return [reassign];
}

export function getSkillsQuestSelectedAssignments ({
    currentAssignment,
    selectedAssignments,
    ...params
}: GetSkillsQuestSelectedAssignmentsParams) {
    const assignmentType = getAssignmentAction({ currentAssignment });

    assignmentType?.forEach((assignmentAction) => {
        selectedAssignments = updateRouteSelectedAssignment({
            selectedAssignments,
            assignmentAction,
            ...params
        });
    });

    return selectedAssignments;
}

export function manageSkillsQuestSelectedAssignments ({
    selectedAssignments,
    activityKey,
    studentKey,
    studentAssignments,
    isSelected
}: ManageSkillsQuestSelectedAssignmentsProps) {
    const currentAssignment = getSkillsQuestCurrentAssignment({
        activityKey,
        studentKey,
        studentAssignments
    });

    selectedAssignments = getSkillsQuestSelectedAssignments({
        currentAssignment,
        selectedAssignments,
        activityKey,
        isSelected,
        userProfileId: studentKey
    });

    return selectedAssignments;
}

export function manageSkillsQuestCellAssignmentsSelected ({
    activityId,
    activityType,
    student: { userProfileId },
    topicId,
    gridCells,
    selectedAssignments,
    ...params
}: ManageSkillsQuestCellAssignmentsSelectedParams) {
    const studentKey = userProfileId.toString();

    if (!activityId) {
        Object.keys(gridCells[userProfileId][topicId]).forEach((activityKey) => {
            selectedAssignments = manageSkillsQuestSelectedAssignments({
                selectedAssignments,
                activityKey,
                studentKey,
                ...params
            });
        });
    } else if (activityType !== null) {
        selectedAssignments = manageSkillsQuestSelectedAssignments({
            selectedAssignments,
            activityKey: activityId,
            studentKey,
            ...params
        });
    }

    return selectedAssignments;
}

export function updateSkillsQuestAssignments ({
    studentAssignments,
    selectedAssignments,
    gridCells
}: UpdateSkillsQuestAssignmentsParams) {
    selectedAssignments = {
        [assign]: {},
        [reassign]: {},
        [unassign]: {},
        [modify]: {}
    };

    Object.keys(gridCells).forEach((studentKey) => {
        Object.keys(gridCells[studentKey]).forEach((topicId) => {
            Object.keys(gridCells[studentKey][topicId]).forEach((activityKey) => {
                selectedAssignments = manageSkillsQuestSelectedAssignments({
                    selectedAssignments,
                    activityKey,
                    studentKey,
                    studentAssignments,
                    isSelected: gridCells[studentKey][topicId][activityKey].isSelected
                });
            });
        });
    });

    return selectedAssignments;
}
